import { defineMessages } from 'react-intl';

export default defineMessages({
    UpdateTheftResolutionTitle: {
        id: 'servicerequest.views.update.theftresolution.title.Update Theft Resolution Title',
        defaultMessage: 'Update Theft Resolution'
    },
    UpdateTheftResolutionField: {
        id: 'servicerequest.views.update.theftresolution.field.Theft Resolution',
        defaultMessage: 'Theft Resolution'
    },
    cancel: {
        id: 'servicerequest.views.update.theftresolution.button.Cancel',
        defaultMessage: 'Cancel'
    },
    send: {
        id: 'servicerequest.views.update.theftresolution.button.Send',
        defaultMessage: 'Send'
    },
    error: {
        id: 'servicerequest.views.update.theftresolution.Error',
        defaultMessage: 'Service Request update failed'
    },
    errorMessage: {
        id: 'servicerequest.views.update.theftresolution.Error Message',
        defaultMessage: 'Sorry, we were unable to update the theft resolution'
    }
});
